<template>
  <div class="secondary--text">{{ formatedLevels }} <slot name="append" /></div>
</template>
<script>
import gql from "fraql";
import { useDisciplineHelper } from "@composables/masterdata/competitions/disciplines";
import { useDifficultyLevelHelper } from "@composables/masterdata/competitions/difficultyLevels";

import { map, uniq, compact, sortBy } from "lodash-es";

export default {
  name: "AppShowDifficultyLevels",
  props: {
    value: {
      type: [String, Object, Array],
      default: () => []
    },
    range: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      ...useDisciplineHelper(),
      ...useDifficultyLevelHelper()
    };
  },
  computed: {
    difficultyLevels() {
      if (!this.value) return false;
      let levels = [];
      // wrap into array if needed
      if (this.value.constructor === Array) {
        levels = this.value;
      } else {
        levels = [this.value];
      }

      levels = map(levels, level => {
        // replace IDs with objects if needed
        if (!level) return null;
        if (typeof level == "string") {
          return this.getDifficultyLevelFromMaster(level);
        } else if (!level.rank || !level.name) {
          return this.getDifficultyLevelFromMaster(level.id);
        } else return level;
      });

      return levels;
    },
    discipline() {
      return this.getDisciplineFromMaster(
        this.difficultyLevels[0].disciplineId
      );
    },
    formatedLevels() {
      let levelNames = this.difficultyLevels;
      if (!levelNames || levelNames.length == 0) return "";

      levelNames = sortBy(levelNames.filter(Boolean), "rank").map(
        item => item.displayName
      );
      levelNames = uniq(compact(levelNames));

      if (levelNames.length == 1) {
        return levelNames[0];
      } else if (this.range) {
        return levelNames[0] + " - " + levelNames[levelNames.length - 1];
      }
      return levelNames.join(" | ");
    }
  },
  fragments: {
    difficultyLevelFields: gql`
      fragment _ on DifficultyLevel {
        id
        name
        rank
        displayName
      }
    `,
    difficultyLevel: gql`
      fragment _ on Competition {
        difficultyLevel {
          id
          name
          displayName
          rank
          disciplineId
        }
      }
    `,
    event: gql`
      fragment _ on Event {
        competitions {
          id
          difficultyLevel {
            id
            name
            displayName
            rank
            disciplineId
          }
        }
      }
    `
  }
};
</script>
